module.exports = __webpack_public_path__ + "static/media/climate_workplacePollutants_5_criteriaSirContainmentPollutants.a2cd57ef.jpg";